module.exports = __webpack_public_path__ + "img/isr.66d49a1a.svg";